import { render, staticRenderFns } from "./ReviewTable.vue?vue&type=template&id=d23b5aac&"
import script from "./ReviewTable.vue?vue&type=script&lang=js&"
export * from "./ReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports